module.exports = __webpack_public_path__ + "r-v3/img/ml_64_00.a71bd6d7.jpg";